import { render, staticRenderFns } from "./MaterialConsume.vue?vue&type=template&id=ae47f17a&scoped=true&"
import script from "./MaterialConsume.vue?vue&type=script&lang=js&"
export * from "./MaterialConsume.vue?vue&type=script&lang=js&"
import style0 from "./MaterialConsume.vue?vue&type=style&index=0&id=ae47f17a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae47f17a",
  null
  
)

export default component.exports